/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
(function() {
  let PROGRESS_COLOR = undefined;
  let FINISHED_COLOR = undefined;
  let TRANSITION_SPEED = undefined;
  let WAIT_DELAY = undefined;
  const Cls = (Buyapowa.Helpers.ProgressButton = class ProgressButton {
    static initClass() {
      PROGRESS_COLOR = "#cccccc";
      FINISHED_COLOR = "#43ac6a";
      TRANSITION_SPEED = 100;
      WAIT_DELAY = 2000;
    }

    constructor(el) {
      this._disableClick = this._disableClick.bind(this);
      this.el = el;
      this.originalColor = $.Color(this.el.css("backgroundColor"));
    }

    started(message) {
      this.oldText = this.el.text();
      this.el.blur();
      this.el.css({cursor: "wait"});
      this.el.on("click", this._disableClick);

      const fn = () => {
        if (message) { return this.el.text(message); }
      };

      return this.el.animate({backgroundColor: PROGRESS_COLOR}, TRANSITION_SPEED, fn);
    }

    finished(success, message) {
      this.el.blur();
      this.el.css({cursor: "not-allowed"});

      const finished = () => {
        this.el.text(message);
        const fn = () => {
          const restore = () => {
            this.el.css({cursor: "", backgroundColor: ""});
            this.el.off("click", this._disableClick);
            return this.el.text(this.oldText);
          };

          return this.el.animate({backgroundColor: this.originalColor}, TRANSITION_SPEED, restore);
        };

        return setTimeout(fn, WAIT_DELAY);
      };

      if (success) {
        return this.el.animate({backgroundColor: FINISHED_COLOR}, TRANSITION_SPEED, finished);
      } else {
        return finished();
      }
    }

    _disableClick(event) {
      return event.preventDefault();
    }
  });
  Cls.initClass();
  return Cls;
})();
